<template>
	<ActionSetNav
		:display="displayNav"
		:name="currentCustomerName"
		:actions="actions"
	/>
</template>
<script>
import ActionSetNav from '@/site-components/actions-set/action-set-nav';
import CustomerNavAction from '@/mixins/customers/customer-navegation-action';

export default {
	name: 'CustomerNavigation',
	mixins: [CustomerNavAction],
	components: {
		ActionSetNav
	}
};
</script>
